import { DEFAULT_VENDOR_ID } from '../../domain/consumer/consumer-profile/types/consumer-profile-default-vendor-id'
import { ConsumerProfilePostSubmissionConfigRulesVariant } from '../../domain/consumer/consumer-profile/types/consumer-profile-post-submission-config/types/consumer-profile-post-submission-config-rules-variant.enum'

export const addVendorIdToPath = (vendorId: string, path: string) => {
  return path.replace(':vendorId', vendorId ?? DEFAULT_VENDOR_ID)
}

export const addApprovedVariantToPath = (path: string, variant?: string) => {
  return path.replace(
    ':variant',
    variant ?? ConsumerProfilePostSubmissionConfigRulesVariant.Default,
  )
}
